module.exports = "/boom/client/fe5b59d42e7d54796992f8f9914d3e45.svg";